import { CollapsibleContext } from "./chunk-P4FH6SY6.js";
import { TransitionComponent } from "./chunk-3HAR27K6.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Collapsible/Collapsible.Panel.tsx
import React, { Fragment, useContext } from "react";
import clsx from "clsx";
import { Disclosure } from "@headlessui/react";
var CollapsiblePanel = _a => {
  var _b = _a,
    {
      children,
      unmount,
      className
    } = _b,
    rest = __objRest(_b, ["children", "unmount", "className"]);
  const {
    isOpen
  } = useContext(CollapsibleContext);
  return /* @__PURE__ */React.createElement(TransitionComponent, {
    as: Fragment,
    variant: "appear-from-top",
    unmount,
    show: isOpen
  }, /* @__PURE__ */React.createElement(Disclosure.Panel, __spreadProps(__spreadValues({}, rest), {
    static: true,
    className: clsx("pd-collapsible__panel", className)
  }), children));
};
var Collapsible_Panel_default = CollapsiblePanel;
export { Collapsible_Panel_default };